import { render, staticRenderFns } from "./PrivateHome.vue?vue&type=template&id=56364890&scoped=true&"
import script from "./PrivateHome.vue?vue&type=script&lang=js&"
export * from "./PrivateHome.vue?vue&type=script&lang=js&"
import style0 from "./PrivateHome.vue?vue&type=style&index=0&id=56364890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56364890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56364890')) {
      api.createRecord('56364890', component.options)
    } else {
      api.reload('56364890', component.options)
    }
    module.hot.accept("./PrivateHome.vue?vue&type=template&id=56364890&scoped=true&", function () {
      api.rerender('56364890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivateHome.vue"
export default component.exports